module.exports = __webpack_public_path__ + "static/img/aboutUs01.9aeaf7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs01.jpg
// module id = 1353
// module chunks = 1